import IAuthState from "../interfaces/IAuthState";

export const authReducer = (state: IAuthState, action: any) => {
    switch (action.type) {
        case "SET_TOKEN": return { ...state, accessToken: action.accessToken, authenticating: false };
        case "REAUTH": return { ...state, authenticating: true };
        case "RESET_AUTH": return { ...state, authenticating: false };
        default: return state;
    }
};
